import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-context-nav',
  templateUrl: './context-nav.component.html',
  styleUrls: ['./context-nav.component.scss']
})
export class ContextNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
